"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionPanel = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var __1 = require("../");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('toggled', 'setToggled', function (outer) {
    return typeof outer.toggled === 'boolean' ? outer.toggled : true;
}), (0, recompose_1.withHandlers)({
    onClick: function (_a) {
        var setToggled = _a.setToggled, toggled = _a.toggled;
        return function () {
            return setToggled(!toggled);
        };
    },
    onClose: function (_a) {
        var setToggled = _a.setToggled;
        return function () { return setToggled(false); };
    }
}), (0, recompose_1.setDisplayName)('AccordionPanel'));
exports.AccordionPanel = enhance(function (_a) {
    var icon = _a.icon, title = _a.title, children = _a.children, toggled = _a.toggled, onClick = _a.onClick, onClose = _a.onClose;
    return (React.createElement("div", { className: "sok-accordion-panel" },
        React.createElement(__1.Accordion, { isOpen: toggled },
            React.createElement(__1.AccordionHeader, { onClick: onClick, isOpen: toggled, icon: icon }, title),
            React.createElement("div", { className: "sok-accordion-panel-content" }, children))));
});
//# sourceMappingURL=index.js.map